import { formatDate } from '@angular/common';
import { Entities } from '@scrollmax/core-nextgen';

export class SpUzenet extends Entities.CoreEntity {

    static override kind = 'ScrollMax\\Scroll\\Entity\\SpUzenet';

    kod: number;

    uzenet: string;

    idopont: string;

    felhasznalonev: string;

    pprol: boolean;

    ppuserid: number;

    aivolt: boolean = false;

    kapcsolt_kod?: string;

    getKod(): number {
        return this.kod;
    }

    getUzenet(): string {
        return this.uzenet.replaceAll("\n", "<br>");
    }

    getNev(): string {
        return this.felhasznalonev;
    }

    isOwnMessage(): boolean {
        return (this.pprol === true && this.ppuserid > -1);
    }

    isAI(): boolean {
        return this.aivolt;
    }

    getNevId(): number {
        return this.ppuserid;
    }

    getKapcsoltKod(): string | undefined {
        return this.kapcsolt_kod.replaceAll('"', '');
    }

    override getCreatedAt(): string {
        return this.idopont;
    }

    override __toString(): string {
        return this.uzenet;
    }

}
